<svg [attr.height]="height"
     [attr.width]="width"
     [class]="svgClass">
  <use [attr.xlink:href]="'#' + name"></use>
</svg>
